import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-under-construction',
  templateUrl: './under-construction.component.html',
  styleUrls: ['./under-construction.component.scss']
})
export class UnderConstructionComponent implements OnInit {

  constructor( ) {}
  previousRoute: string;
  previousRouteId:string;
  ngOnInit(): void {
    this.previousRoute = JSON.parse(localStorage.getItem('onderneming'));
    // this.previousRouteId = JSON.parse(localStorage.getItem('ondernemingId'));
    // setTimeout(() => {
    //   if(this.previousRoute && this.previousRouteId)
    //   {
    //     this.router.navigate(['/login']);
    //     console.log("ERROR IN AUTH SERVICE ");
    //   }
    //   else
    //   {
    //     this.router.navigate(["/", pathNaam, pathId,"tools"]);
    //   }
      
    // }, 2500);
  }

}
